import { render, staticRenderFns } from "./veJkyProjectShen.vue?vue&type=template&id=70089e6c&scoped=true"
import script from "./veJkyProjectShen.vue?vue&type=script&lang=js"
export * from "./veJkyProjectShen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70089e6c",
  null
  
)

export default component.exports